
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

interface ReplyFormProps {
  onSubmit: (content: string) => Promise<void>;
  onCancel: () => void;
  isLoading: boolean;
}

const ReplyForm = ({ onSubmit, onCancel, isLoading }: ReplyFormProps) => {
  const [content, setContent] = useState("");

  const handleSubmit = async () => {
    if (content.trim()) {
      await onSubmit(content);
      setContent("");
    }
  };

  return (
    <div className="mt-3">
      <Textarea
        placeholder="Write a reply..."
        className="min-h-[80px] text-sm mb-2"
        value={content}
        onChange={(e) => setContent(e.target.value)}
      />
      <div className="flex justify-end gap-2">
        <Button 
          variant="outline" 
          size="sm" 
          onClick={() => {
            onCancel();
            setContent("");
          }}
        >
          Cancel
        </Button>
        <Button 
          size="sm" 
          onClick={handleSubmit}
          disabled={isLoading || !content.trim()}
        >
          Post Reply
        </Button>
      </div>
    </div>
  );
};

export default ReplyForm;
